/* eslint-disable */
import Swiper from 'swiper/bundle'
import Cookieconsent from 'vanilla-cookieconsent'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import mapboxgl from 'mapbox-gl';
import jssocials from 'jssocials';
import select2 from 'select2';

export default {
    init() {
      // JavaScript to be fired on all pages

        let scroll = $(window).scrollTop();
        let mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
        mapboxgl.accessToken = 'pk.eyJ1IjoiYmFyY2Vsb25hLWNvIiwiYSI6ImNsbm9mZmN3bzBpM2Yya29kcWYxbnZpcGkifQ.gsHaJQAk_Ua4vBbt3DxNGQ';

        $(function () {

            $(window).scroll(function () {
                scroll = $(window).scrollTop();
                posHeader();
            });


          // Blur on click
            $('a, button, input[type=\'submit\'], .btn').on('click', function () {
                $(this).blur();
            });


          // Button scroll down
            $('.js_btn-scroll-down').on('click', function () {
                $('html,body').stop().animate({
                    scrollTop: $(this).closest('.module').offset().top + $(this).closest('.module').outerHeight(true),
                }, 1000);
            });


          // ========================================
          // Header
          // ========================================
            if ($(window).width() <= 1024) {
                $('.js_toggle-menu').on('click', function () {
                    $(this).toggleClass('close');
                    $('body').toggleClass('menu-active');
                });

                $('#header .menu-primary .menu > li.menu-item-has-children > a').on('click', function (e) {
                    e.preventDefault();
                    let $elt = $(this);
                    $elt.closest('li').siblings('li').find('a').removeClass('active');
                    $elt.closest('li').siblings('li').find('.sub-menu').slideUp(400);
                    $elt.toggleClass('active').next('.sub-menu').slideToggle(400);
                });
            }

            $('.js_btn-toggle-search').on('click', function () {
                $('body').toggleClass('search-active');
                $('html').toggleClass('disable-scroll');
                setTimeout(function () {
                    if ($('body').hasClass('search-active')) {
                        $('.search-form .search-field').focus();
                    }
                }, 100);
            });

            let position = $(window).scrollTop();
            let keepHeaderVisible = false;
            let headerSticky = 0;
            let $header = $('#header');
            let headerHeight;
            let headerTop;
            let $headerContent = jQuery('.header-page-content');

            function posHeader()
            {
                headerHeight = $header.outerHeight(true);
                headerTop = $('#header').offset().top;

                if (scroll <= headerTop) {
                    $('body').removeClass('scroll-up scroll-down');
                } else if (scroll > headerTop) {
                    $('body').addClass('scroll-down').removeClass('scroll-up');
                } else {
                    $('body').addClass('scroll-up').removeClass('scroll-down');
                }

                if ($(document).width() > 1024) {
                    if (scroll > position) {
                      // Scroll down
                        if (scroll > headerHeight + headerTop) {
                              // Cache le header
                              headerSticky = headerHeight + headerTop;
                              $header.addClass('transition');
                        } else {
                            if (!keepHeaderVisible) {
                                // Cache le header progressivement suivant le scroll
                                headerSticky = scroll;
                                $header.removeClass('transition');
                            }
                        }
                    } else {
                      // Scroll Up
                        if (scroll > headerHeight + headerTop) {
                          // Affiche le header
                            headerSticky = headerTop;
                            $header.addClass('transition');
                            keepHeaderVisible = true; // Garde le header visible jusqu'en haut de page
                        } else if (keepHeaderVisible && scroll > headerTop) {
                            headerSticky = headerTop;
                            $header.addClass('transition');
                        } else {
                          // Affiche le header progressivement suivant le scroll
                            headerSticky = scroll;
                            $header.removeClass('transition');
                            keepHeaderVisible = false; // Garde le header visible jusqu'en haut de page
                        }
                    }
                    if (scroll <= 0) {
                        headerSticky = 0;
                        keepHeaderVisible = false;
                    }

                    $('#header .header-wrapper').css('transform', 'translateY(-' + headerSticky + 'px)');

                    position = scroll;
                } else {
                    $('#header .header-wrapper').css('transform', '');
                }
            }

            posHeader();


          // ========================================
          // Modal filtres
          // ========================================
            $('body').on('click', '.js-choice-collection', function () {
                $('#choices .btn-submit').removeAttr('disabled')
            }).on('click', '.js-choice-job', function () {
                $('#choices .btn-submit').removeAttr('disabled')
            }).on('click', '.js-choice-norme', function () {
                $('#choices .btn-submit').removeAttr('disabled')
            }).on('click', '.js-choice-type', function () {
                $('#choices .btn-submit').removeAttr('disabled')
            }).on('click', '.js-choice-need', function () {
                $('#choices .btn-submit').removeAttr('disabled')
            })

            function updateTextArea()
            {
                var allNormeVals = $('input.js-choice-norme:checked').map(
                    function () {
                        return this.value;
                    }
                ).get().join();

                if (allNormeVals.length > 0) {
                        $('#choices .btn-submit').removeAttr('disabled')
                } else {
                    if ($('input.js-choice-collection:checked')) {
                    } else {
                        $('#choices .btn-submit').attr('disabled', 'disabled')
                    }
                }
                $('#normeValue').val(allNormeVals)


                var allTypeVals = $('input.js-choice-type:checked').map(
                    function () {
                        return this.value;
                    }
                ).get().join();

                if (allTypeVals.length > 0) {
                        $('#choices .btn-submit').removeAttr('disabled')
                } else {
                    if ($('input.js-choice-collection:checked')) {
                    } else {
                        $('#choices .btn-submit').attr('disabled', 'disabled')
                    }
                }
                $('#typeValue').val(allTypeVals)
            }

            $(function () {
                $('#choices input').click(updateTextArea);
                updateTextArea();

                $('body').on('click', '#choices .btn-submit', function (e) {
                    e.preventDefault();
                    if ($('#normeValue').val().length < 1) {
                        $('#normeValue').remove()
                    }
                    if ($('#typeValue').val().length < 1) {
                        $('#typeValue').remove()
                    }
                    $('#choices').submit();
                })
            });

            var inputChecked = $('#choices input');
            if (inputChecked.checked) {
                $('#choices .btn-submit').removeAttr('disabled')
            }


          // ========================================
          // Footer
          // ========================================
            $('.js_footer-btn-scroll').on('click', function () {
                $('html,body').stop().animate({
                    scrollTop: 0,
                }, 1500);
            });


            $('#refTerms').select2({
              // allowClear: true
                allowClear: false
            });

          // ========================================
          // Modules
          // ========================================
          // Module Hero
            if ($('.module-hero .item').length > 1) {
                new Swiper('.js_slider-hero', {
                    loop: true,
                    speed: 1000,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.js_slider-hero-btn-next',
                        prevEl: '.js_slider-hero-btn-prev',
                    },
                });
            }


          // Module News slider
            $('.js_news-slider').each(function (index) {
                let elt = this;
                $(elt).siblings('.js_news-slider-btn-prev, .js_news-slider-btn-next').addClass('index-' + index);

                let params = {
                    loop: true,
                    speed: 750,
                    navigation: {
                        nextEl: '.js_news-slider-btn-next.index-' + index,
                        prevEl: '.js_news-slider-btn-prev.index-' + index,
                    },
                };

                if ($(elt).hasClass('columns-2')) {
                    params.spaceBetween = 26;
                    params.slidesPerView = 1;
                    params.breakpoints = {
                        601: {
                            slidesPerView: 2,
                        },
                    };
                } else if ($(elt).hasClass('columns-3')) {
                    params.spaceBetween = 26;
                    params.slidesPerView = 1;
                    params.breakpoints = {
                        601: {
                            slidesPerView: 2,
                        },
                        1025: {
                            slidesPerView: 3,
                        },
                    };
                } else {
                    params.spaceBetween = 26;
                    params.slidesPerView = 'auto';
                }

                new Swiper(elt, params);

            });


          // Module Logos slider
            $('.js_logos-slider').each(function (index) {
                let elt = this;
                $(elt).siblings('.js_logos-slider-btn-prev, .js_logos-slider-btn-next').addClass('index-' + index);
                new Swiper(elt, {
                    loop: true,
                    speed: 750,
                    slidesPerView: 2,
                    spaceBetween: 20,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.js_logos-slider-btn-next.index-' + index,
                        prevEl: '.js_logos-slider-btn-prev.index-' + index,
                    },
                    breakpoints: {
                        481: {
                            slidesPerView: 3,
                        },
                        601: {
                            slidesPerView: 4,
                        },
                        961: {
                            slidesPerView: 5,
                            spaceBetween: 26,
                        },
                        1025: {
                            slidesPerView: 6,
                        },
                    },
                });
            });


          // Module Accordion
            $('.js_toggle-accordion').on('click', function () {
                let $elt = $(this);
                let speed = 400;
                if ($elt.hasClass('active')) {
                    $elt.closest('.accordion').find($('.title')).removeClass('active').next('.txt').slideUp(speed);
                } else {
                    $elt.closest('.accordion').find($('.title')).removeClass('active').next('.txt').slideUp(speed);
                    $elt.addClass('active').next('.txt').slideDown(speed);
                }
            });


          // Module Images slider
            let sliderImage = [];
            $('.js_images-slider').each(function (index) {
                let elt = this;
                if ($(elt).find('.item').length > 1) {
                    $(elt).data('index', index); // Utilisé pour la popin du module gallery
                    $(elt).siblings('.js_images-slider-btn-prev, .js_images-slider-btn-next, .js_images-slider-pagination').addClass('index-' + index);

                    sliderImage[index] = new Swiper(elt, {
                        loop: true,
                        speed: 750,
                        navigation: {
                            nextEl: '.js_images-slider-btn-next.index-' + index,
                            prevEl: '.js_images-slider-btn-prev.index-' + index,
                        },
                        pagination: {
                            el: '.js_images-slider-pagination.index-' + index,
                            type: 'bullets',
                            clickable: true,
                        },
                    });
                }
            });


          // Module Video
            $('.js_btn-video').on('click', function () {
                let $elt = $(this);
                let $video = $elt.closest('.video');
                let $iframe = $video.find('iframe');
                let src = 'https://www.youtube-nocookie.com/embed/' + $elt.data('src') + '?rel=0&showinfo=0&enablejsapi=1&autoplay=1';
                $iframe.attr('src', src);
                $video.addClass('active');
                setTimeout(function () {
                    $iframe[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                }, 600);
            });


          // Module References
            $('.js_references-slider').each(function () {
                let elt = this;
                if ($(elt).find('.sub-item').length > 1) {
                    new Swiper(elt, {
                        loop: true,
                        speed: 750,
                        allowTouchMove: false,
                        navigation: {
                            nextEl: '.js_references-slider-btn-next',
                            prevEl: '.js_references-slider-btn-prev',
                        },
                        pagination: {
                            el: '.js_references-slider-pagination',
                            type: 'bullets',
                            clickable: true,
                        },
                    });
                }
            });
            $('.js_references-popin-slider').each(function () {
                let elt = this;
                if ($(elt).find('.item').length > 1) {
                    new Swiper(elt, {
                        loop: true,
                        speed: 750,
                        navigation: {
                            nextEl: '.js_references-popin-slider-btn-next',
                            prevEl: '.js_references-popin-slider-btn-prev',
                        },
                        pagination: {
                            el: '.js_references-popin-slider-pagination',
                            type: 'bullets',
                            clickable: true,
                        },
                    });
                }
            });


          // Module Map
            $('.js_load-map').each(function () {
                let elt = this;
                let markers = $(elt).attr('data-markers');
                const map = new mapboxgl.Map({
                    container: $(elt).attr('id'),
                    style: 'mapbox://styles/mapbox/streets-v11',
                    center: [$(elt).attr('data-lng'), $(elt).attr('data-lat')],
                    zoom: 16,
                });
                map.scrollZoom.disable();
              // new mapboxgl.Marker({color: $(elt).attr('data-color')})
              //     .setLngLat([$(elt).attr('data-lng'), $(elt).attr('data-lat')])
              //     .addTo(map);

                var coor = jQuery.parseJSON(markers);
                var bounds = new mapboxgl.LngLatBounds();

                coor.forEach(function (key) {
                    const el = document.createElement('div');
                    const containerLogo = document.createElement('div')
                    containerLogo.setAttribute('class', 'container-pin');

                    const logo = document.createElement("IMG");
                    logo.setAttribute('class', 'img-pin');
                    logo.src = $(elt).attr('data-pin');

                    el.className = 'marker';
                  // el.setAttribute('style', "content: url('" + $(elt).attr('data-pin') + "')");
                    containerLogo.append(logo);
                    el.append(containerLogo);
                  // new mapboxgl.Marker({color: $(elt).attr('data-color')})
                    new mapboxgl.Marker(el)
                    .setLngLat([key[0], key[1]])
                    .addTo(map);

                    bounds.extend(key);
                });

              // permet d'ajuster le zoom en fonction des markers
                map.fitBounds(bounds, {padding: 100});
                var mapLat = map.getBounds().getCenter().lat;
                var mapLong = map.getBounds().getCenter().long;
                map.setCenter = (mapLat, mapLong);
                var zoomAjust = coor.length > 1 ? 2 : 1;
                var mapZoom = map.getZoom()
                var newZoom = mapZoom - zoomAjust;
                map.setZoom(newZoom);
            });


          // Module Share
            var url = "http://google.com";
            var text = "Some text to share";

            $("#share").jsSocials({
              // url: url,
              // text: text,
                showLabel: false,
                showCount: false,
                shares: ["email", "twitter", "facebook", "linkedin", "pinterest", "whatsapp", "messenger"]
            });


          // ========================================
          // Popin
          // ========================================
            function openPopin(popin, slide)
            {
                $('.popin-wrapper[data-popin="' + popin + '"]').show(0).addClass('active');
                $('html').addClass('disable-scroll');
                if (slide) {
                    sliderImage[$('.popin-wrapper[data-popin="' + popin + '"]').find('.slider').data('index')].slideTo(slide);
                }
            }

            function closePopin(popin)
            {
                if (popin) {
                  // console.log('1');
                    $('.popin-wrapper[data-popin="' + popin + '"]').removeClass('active');
                    setTimeout(function () {
                        $('html').removeClass('disable-scroll');
                        $('.popin-wrapper[data-popin="' + popin + '"]').hide(0);
                    }, 600);
                } else {
                  // console.log('2');
                    $('.popin-wrapper').removeClass('active');
                    setTimeout(function () {
                        $('html').removeClass('disable-scroll');
                        $('.popin-wrapper').hide(0);
                    }, 600);
                }
            }

            $(document).on('click', '.js_open-popin', function () {
                openPopin($(this).data('popin'), $(this).data('slide'));
            });


            $(document).on('click', '.js_close-popin', function () {
                closePopin();
            });
            $(document).on('click', '.popin-wrapper', function (e) {
                if (e.target !== this) {
                    return;
                }
                closePopin();
            });


          // ========================================
          // Popin Alerte
          // ========================================
            $(document).on('click', '.js_close-popin-alert', function () {
                sessionStorage['alerte'] = 'alertClose';
            });

            $(document).on('click', '.popin-alert-wrapper', function (e) {
                if (e.target !== this) {
                    return;
                }
                sessionStorage['alerte'] = 'alertClose';
            });
            let alerte = $('.popin-alert-wrapper');
            let data = sessionStorage['alerte'];
            if (data === 'alertClose') {
                closePopin('alert');
            } else if (alerte.length > 0) {
                openPopin('alert');
            }


          // ========================================
          // Popin Find shoes
          // ========================================
            $('.js_open-popin-find-shoes').on('click', function () {
                openPopin('find-shoes');
            });
        });


    // ========================================
    // Animations
    // ========================================
    gsap.registerPlugin(ScrollTrigger);

    $(window).load(function () {
        $(window).trigger('resize');
        if ($('.loader').length > 0) {
            gsap.to('.loader img', {duration: 1.1, y: -75, ease: 'power1.inOut'}, '+.5');
            gsap.to('.loader', {duration: .9, opacity: 0}, '+.8');
            gsap.to('.loader', {duration: 0, className: 'loader disable'}, '+1.8');
        }
    });

    $(function () {

      // Main
        gsap.to('#main', {duration: .7, opacity: 1});

      // Pour activer / désactiver les animations
        if (!$('body').hasClass('woocommerce')) {
            if ($('.module.has-background-image.parallax').length > 0) {
                $('.module.has-background-image.parallax').each(function (index, elt) {
                    gsap.to($(elt).find('.background'), {
                        yPercent: 25,
                        ease: "none",
                        scrollTrigger: {
                            trigger: elt,
                            scrub: true
                        },
                    });
                });
            }


          // Module Hero - list
            if ($('.module-hero.mode-list').length > 0) {
                $('.module-hero.mode-list').each(function (index, elt) {
                    gsap.from($(elt).find('.item:nth-child(1)'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        x: -75,
                        opacity: 0,
                    });
                    gsap.from($(elt).find('.item:nth-child(2)'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        x: 75,
                        opacity: 0,
                    });
                });
            }


          // Module Posts list
            if ($('.module-posts-list').length > 0) {
                $('.module-posts-list').each(function (index, elt) {
                    let tlModulePostList = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModulePostList
                    .from($(elt).find('.title-module'), .7, {y: 25, opacity: 0})
                    .from($(elt).find('.item'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    }, '-=.5')
                });
            }


          // Module News slider
            if ($('.module-news-slider').length > 0) {
                $('.module-news-slider').each(function (index, elt) {
                    let tlModuleNewsSlider = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleNewsSlider
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.slider-wrapper'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                    .from($(elt).find('.btn-more-wrapper'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                });
            }


          // Module Text image
            if ($('.module-text-image').length > 0) {
                $('.module-text-image').each(function (index, elt) {
                    gsap.from($(elt).find('.img-left .col-1'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        x: -75,
                        opacity: 0,
                    });
                    gsap.from($(elt).find('.img-left .col-2'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        x: 75,
                        opacity: 0,
                    });
                    gsap.from($(elt).find('.img-right .col-1'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        x: 75,
                        opacity: 0,
                    });
                    gsap.from($(elt).find('.img-right .col-2'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        x: -75,
                        opacity: 0,
                    });
                });
            }


          // Module Text
            if ($('.module-text').length > 0) {
                $('.module-text').each(function (index, elt) {
                    let tlModuleText = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleText
                    .from($(elt).find('.txt'), {duration: .7, y: 75, opacity: 0})
                    .from($(elt).find('.btn-wrapper'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                });
            }


          // Module Head text
            if ($('.module-head-text').length > 0) {
                $('.module-head-text').each(function (index, elt) {
                    gsap.from($(elt).find('.col'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    });
                });
            }


          // Module Logos slider
            if ($('.module-logos-slider').length > 0) {
                $('.module-logos-slider').each(function (index, elt) {
                    let tlModuleLogosSlider = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleLogosSlider
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.slider-wrapper'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                });
            }


          // Module Contact
            if ($('.module-contact').length > 0) {
                $('.module-contact').each(function (index, elt) {
                    let tlModuleContact = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleContact
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.col-1'), {duration: .7, x: -75, opacity: 0}, '-=.5')
                    .from($(elt).find('.col-2'), {duration: .7, x: 75, opacity: 0}, '-=.7')
                });
            }


          // Module Form
            if ($('.module-form').length > 0) {
                $('.module-form').each(function (index, elt) {
                    let tlModuleForm = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleForm
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.gfield'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    }, '-=.5')
                    .from($(elt).find('.gform_footer'), {duration: .7, y: 25, opacity: 0})
                });
            }


          // Module Map
            if ($('.module-map').length > 0) {
                $('.module-map').each(function (index, elt) {
                    let tlModuleMap = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleMap
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.map-wrapper'), {duration: .7, opacity: 0}, '-=.5')
                });
            }


          // Module Accordion
            if ($('.module-accordion').length > 0) {
                $('.module-accordion').each(function (index, elt) {
                    let tlModuleAccordion = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleAccordion
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.title'), {
                        duration: .7,
                        x: 75,
                        opacity: 0,
                        stagger: 0.1,
                    }, '-=.5')
                });
            }


          // Module Images slider
            if ($('.module-images-slider').length > 0) {
                $('.module-images-slider').each(function (index, elt) {
                    let tlModuleImagesSlider = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleImagesSlider
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.slider-wrapper'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                    .from($(elt).find('.btn-more-wrapper'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                });
            }


          // Module Vidéo
            if ($('.module-video').length > 0) {
                $('.module-video').each(function (index, elt) {
                    let tlModuleVideo = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleVideo
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.video'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                });
            }


          // Module Quote
            if ($('.module-quote').length > 0) {
                $('.module-quote').each(function (index, elt) {
                    let tlModuleQuote = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleQuote
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.txt'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                    .from($(elt).find('.illus-wrapper'), {duration: .7, y: 75, opacity: 0}, '-=.6')
                    .from($(elt).find('.name'), {duration: .7, y: 75, opacity: 0}, '-=.6')
                    .from($(elt).find('.function'), {duration: .7, y: 75, opacity: 0}, '-=.6')
                    .from($(elt).find('.title'), {duration: .7, y: 75, opacity: 0}, '-=.6')
                    .from($(elt).find('.desc'), {duration: .7, y: 75, opacity: 0}, '-=.6')
                    .from($(elt).find('.btn-wrapper'), {duration: .7, y: 75, opacity: 0}, '-=.6')
                });
            }


          // Module References
            if ($('.module-references').length > 0) {
                $('.module-references').each(function (index, elt) {
                    let tlModuleReferences = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleReferences
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.tabs'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                    .from($(elt).find('.list .item'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    }, '-=.5')
                    .from($(elt).find('.btn-more-wrapper'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                });
            }


          // Module Gallery
            if ($('.module-gallery').length > 0) {
                $('.module-gallery').each(function (index, elt) {
                    let tlModuleGallery = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleGallery
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.tabs'), {duration: .7, y: 75, opacity: 0}, '-=.5')
                    .from($(elt).find('.list .item'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    }, '-=.6')
                });
            }


          // Module Icons
            if ($('.module-icons').length > 0) {
                $('.module-icons').each(function (index, elt) {
                    let tlModuleIcons = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleIcons
                    .from($(elt).find('.title-module'), {duration: .7, y: 25, opacity: 0})
                    .from($(elt).find('.list .item'), {
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    }, '-=.5')
                });
            }


          // Module Link
            if ($('.module-link').length > 0) {
                $('.module-link').each(function (index, elt) {
                    let tlModuleLink = gsap.timeline({
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                    });
                    tlModuleLink
                    .from($(elt).find('.btn-wrapper'), {duration: .7, y: 75, opacity: 0})
                });
            }


          // Page Archive news
            if ($('.page-archive-news').length > 0) {
                $('.page-archive-news').each(function (index, elt) {
                    gsap.from($(elt).find('.title-page-wrapper'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        y: 25,
                        opacity: 0,
                    });
                    gsap.from($(elt).find('.tabs'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        y: 75,
                        opacity: 0,
                    });
                    gsap.from($(elt).find('.list-single .item'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        y: 75,
                        opacity: 0,
                        stagger: 0.1,
                    });
                });
            }


          // Page Archive references
            if ($('.page-archive-references').length > 0) {
                $('.page-archive-references').each(function (index, elt) {
                    gsap.from($(elt).find('.title-page-wrapper'), {
                        scrollTrigger: {
                            trigger: elt,
                            start: 'top 80%',
                        },
                        duration: .7,
                        y: 25,
                        opacity: 0,
                    });
                });
            }
        }


      // ========================================
      // Cookie
      // ========================================
        let cc = initCookieConsent();

      // run plugin with your configuration
        cc.run({
            current_lang: 'fr-FR',
            auto_language: 'document',

            gui_options: {
                consent_modal: {
                    layout: 'box',              // box/cloud/bar
                    position: 'bottom left',    // bottom/middle/top + left/right/center
                    transition: 'slide',        // zoom/slide
                },
                settings_modal: {
                    layout: 'box',              // box/bar
                    // position : 'left',       // left/right
                    transition: 'slide',        // zoom/slide
                },
            },
          // si les cookies sont acceptés (ne pas confondre avec le fait de cliquer sur accepter)
            onAccept: function (cookie) {
              // document.querySelector('.cookies-button').classList.add('is-visible');
            },
            onFirstAction: function (cookie) {
                window.location.reload();
            },
            onChange: function (cookie) {
                window.location.reload();
            },

          languages: {
            'fr-FR': {
              consent_modal: {
                title: 'Hello ! On vous propose des <span class="large">Cookies</span>',
                description: '"Jallatte utilise des cookies et autres traceurs afin de permettre aux services principaux du site de fonctionner de manière optimale, afin de fournir certaines fonctionnalités, de mesure d\'audience, et de publicité.<br><br>À l’exception des cookies strictement nécessaires au fonctionnement du site, les cookies et autres traceurs ne peuvent être déposés qu’avec votre consentement. Nous conservons votre choix pendant 6 mois.<br><br>Vous pouvez librement accepter ou refuser les cookies en cliquant sur les cases à cet effet ci-dessous. Vous avez également la possibilité de changer d’avis à tout moment en accédant à ce panneau de gestion des cookies via l’onglet dédié, situé en bas de chaque page du site. Le refus de certains cookies ou le retrait de votre consentement peut affecter les fonctionnalités du site.<br><br>Pour plus d’informations sur les cookies et traceurs utilisés, vous pouvez consulter notre <a href="/cookies/" class="cc-link">Politique cookies</a>.',
                primary_btn: {
                  text: 'J\'accepte',
                  role: 'accept_all',             // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                  text: 'Je refuse',
                  role: 'accept_necessary',        // 'settings' or 'accept_necessary'
                },
              },
              settings_modal: {
                title: 'Gestion de préférence des cookies',
                save_settings_btn: 'Enregistrer',
                accept_all_btn: 'Tout accepter',
                reject_all_btn: 'Tout rejeter',
                close_btn_label: 'Fermer',
                cookie_table_headers: [
                  {col1: 'Nom'},
                  {col2: 'Domaine'},
                  {col3: 'Expiration'},
                  {col4: 'Description'},
                ],
                blocks: [
                  {
                    description: 'Sur ce site, nous utilisons des cookies pour mesurer notre audience. Vous pouvez sélectionner ici les services que vous allez autoriser.',
                  }, {
                    title: 'Cookies nécessaires au bon fonctionnement du site',
                    description: 'Ces cookies sont indispensables au bon fonctionnement du site internet. Ces cookies sont essentiels au bon fonctionnement du site, vous ne pouvez pas les désactiver.',
                    toggle: {
                      value: 'necessary',
                      enabled: true,
                      readonly: true,
                    },
                  }, {
                    title: 'Publicitaires (ou presque)',
                    description: 'Pour concevoir ce site nous avons fait appel à une société bien de chez nous (à Nîmes pour être précis) et cette société s’appuie pour rendre votre site plus dynamique sur des technologies tierces : YouTube, openmap, etc… Pour profiter de l’ensemble des technologies nous vous invitons à accepter ces cookies.',
                    toggle: {
                      value: 'advertising',
                      enabled: false,
                      readonly: false,
                    },
                  },
                ],
              },
            },
            'en-GB': {
              consent_modal: {
                title: 'Hello ! We offer <span class="large">Cookies</span>',
                description: '«Jallatte uses cookies and other trackers to enable the site’s main services to function optimally, to provide certain functionalities, to measure audience size, and for advertising purposes.<br><br>With the exception of cookies strictly necessary for the operation of the site, cookies and other identifiers may only be deposited with your consent. We retain your choice for 6 months.<br><br>You can freely accept or refuse cookies by clicking on the appropriate boxes below. You can also change your mind at any time by accessing this cookie management panel via the dedicated tab at the bottom of each page of the site. Refusing certain cookies or withdrawing your consent may affect the functionality of the site.<br><br>For more information on the cookies and trackers we use, please consult our <a href="/en/cookie-options/" class="cc-link">Cookie Policy</a>.',
                primary_btn: {
                  text: 'I agree',
                  role: 'accept_all',             // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                  text: 'I refuse',
                  role: 'accept_necessary',        // 'settings' or 'accept_necessary'
                },
              },
              settings_modal: {
                title: 'Cookie preference management',
                save_settings_btn: 'Register',
                accept_all_btn: 'Accept all',
                reject_all_btn: 'Reject all',
                close_btn_label: 'Close',
                cookie_table_headers: [
                  {col1: 'Nom'},
                  {col2: 'Domaine'},
                  {col3: 'Expiration'},
                  {col4: 'Description'},
                ],
                blocks: [
                  {
                    description: 'On this site, we use cookies to measure our audience. You can select here the services you will allow.',
                  }, {
                    title: 'Cookies necessary for the proper functioning of the site',
                    description: 'These cookies are essential for the proper functioning of the website. These cookies are essential to the proper functioning of the site, you can not disable them.',
                    toggle: {
                      value: 'necessary',
                      enabled: true,
                      readonly: true,
                    },
                  }, {
                    title: 'Advertisers (or almost)',
                    description: 'To design this site we have called upon a local company (in Nîmes to be precise) and this company relies on third party technologies to make your site more dynamic: YouTube, openmap, etc... To take advantage of all these technologies we invite you to accept these cookies.',
                    toggle: {
                      value: 'advertising',
                      enabled: false,
                      readonly: false,
                    },
                  },
                ],
              },
            },
            'it-IT': {
              consent_modal: {
                title: 'Ciao ! Vi offriamo i <span class="large">Cookie</span>',
                description: '“Jallatte” utilizza cookie e altri traccianti per consentire il funzionamento ottimale dei principali servizi del sito, al fine di fornire alcune funzionalità, la misurazione dell’audience e la pubblicità.<br><br> Ad eccezione dei cookie strettamente necessari per il funzionamento del sito, i cookie e gli altri tracciatori possono essere depositati solo con il vostro consenso. Conserviamo la vostra scelta per 6 mesi.<br><br>Potete liberamente accettare o rifiutare i cookie cliccando sulle apposite caselle sottostanti. Potete anche cambiare idea in qualsiasi momento accedendo al pannello di gestione dei cookie tramite la scheda dedicata in fondo a ogni pagina del sito. Il rifiuto di alcuni cookie o la revoca del consenso possono compromettere la funzionalità del sito.<br><br>Per maggiori informazioni sui cookie e sui tracker utilizzati, è possibile consultare la nostra <a href="/it/gestione-dei-cookie/" class="cc-link">Cookie Policy</a>.',
                primary_btn: {
                  text: 'Accetto',
                  role: 'accept_all',             // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                  text: 'Rifiuto',
                  role: 'accept_necessary',        // 'settings' or 'accept_necessary'
                },
              },
              settings_modal: {
                title: 'Gestione delle preferenze dei cookie',
                save_settings_btn: 'Registro',
                accept_all_btn: 'Accettare tutto',
                reject_all_btn: 'Rifiutare tutto',
                close_btn_label: 'Chiudere',
                cookie_table_headers: [
                  {col1: 'Nom'},
                  {col2: 'Domaine'},
                  {col3: 'Expiration'},
                  {col4: 'Description'},
                ],
                blocks: [
                  {
                    description: 'Su questo sito utilizziamo i cookie per misurare il nostro pubblico. Qui è possibile selezionare i servizi che si desidera consentire.',
                  }, {
                    title: 'Cookie necessari per il corretto funzionamento del sito',
                    description: 'Questi cookie sono essenziali per il corretto funzionamento del sito web. Questi cookie sono essenziali per il corretto funzionamento del sito, non è possibile disattivarli.',
                    toggle: {
                      value: 'necessary',
                      enabled: true,
                      readonly: true,
                    },
                  }, {
                    title: 'Pubblicità (o quasi)',
                    description: 'Per la realizzazione di questo sito ci siamo rivolti ad un\'azienda locale (di Nîmes per la precisione) che si avvale di tecnologie di terze parti per rendere il sito più dinamico: YouTube, openmap, ecc... Per usufruire di tutte queste tecnologie vi invitiamo ad accettare i seguenti cookie.',
                    toggle: {
                      value: 'advertising',
                      enabled: false,
                      readonly: false,
                    },
                  },
                ],
              },
            },
            'es-ES': {
                consent_modal: {
                    title: '¡HOLA! LE PROPONEMOS <span class="large">Cookies</span>',
                    description: '«Jallatte» utiliza cookies y otros rastreadores para permitir el funcionamiento óptimo de los principales servicios del sitio, con el fin de ofrecer determinadas funcionalidades, medición de audiencia y publicidad.<br><br>A excepción de las cookies estrictamente necesarias para el funcionamiento del sitio, las cookies y otros trazadores sólo pueden depositarse con su consentimiento. Conservamos su elección durante 6 meses.<br><br>Puede aceptar o rechazar libremente las cookies haciendo clic en las casillas correspondientes. También puede cambiar de opinión en cualquier momento accediendo al panel de gestión de cookies a través de la pestaña correspondiente situada en la parte inferior de cada página del sitio. Rechazar determinadas cookies o retirar su consentimiento puede afectar a la funcionalidad del sitio.<br><br>Para más información sobre las cookies y rastreadores utilizados, puede consultar nuestra <a href="/es/gestion-de-cookies/" class="cc-link">Política de Cookies</a>',
                    primary_btn: {
                    text: 'Acepto',
                    role: 'accept_all',             // 'accept_selected' or 'accept_all'
                  },
                  secondary_btn: {
                      text: 'Rechazo',
                      role: 'accept_necessary',        // 'settings' or 'accept_necessary'
                    },
                },
                settings_modal: {
                  title: 'GESTIÓN PREFERENTE DE COOKIES',
                  save_settings_btn: 'Registro',
                  accept_all_btn: 'ACEPTAR TODO',
                  reject_all_btn: 'RECHAZAR TODO',
                  close_btn_label: 'Close',
                  cookie_table_headers: [
                      {col1: 'Nom'},
                    {col2: 'Domaine'},
                    {col3: 'Expiration'},
                    {col4: 'Description'},
                ],
                blocks: [
                    {
                        description: 'En este sitio utilizamos cookies para medir nuestra audiencia. Aquí puede seleccionar los servicios que desea autorizar.',
                    }, {
                        title: 'COOKIES NECESARIAS PARA QUE EL SITIO FUNCIONE CORRECTAMENTE',
                        description: 'Estas cookies son esenciales para que el sitio web funcione correctamente. Estas cookies son esenciales para que el sitio web funcione correctamente. No puede desactivarlas.',
                        toggle: {
                            value: 'necessary',
                        enabled: true,
                        readonly: true,
                      },
                    }, {
                        title: 'Pubblicidad (o quasi)',
                        description: 'Para diseñar este sitio hemos recurrido a una empresa local (de Nîmes para ser precisos) y esta empresa se apoya en tecnologías de terceros para dinamizar su sitio: YouTube, openmap, etc. Para aprovechar todas estas tecnologías le invitamos a aceptar estas cookies.',
                        toggle: {
                            value: 'advertising',
                        enabled: false,
                        readonly: false,
                      },
                    },
                ],
            },
            },
            'de-DE': {
                consent_modal: {
                title: 'HELLO! WIR BIETEN IHNEN <span class="large">Cookies</span>',
                description: 'funktionieren, um bestimmte Funktionen bereitzustellen, die Besucherzahlen zu messen und Werbung zu betreiben.<br><br>Mit Ausnahme von Cookies, die für das Funktionieren der Website unbedingt erforderlich sind, können Cookies und andere Tracker nur mit Ihrer Zustimmung abgelegt werden. Wir speichern Ihre Wahl sechs Monate lang.<br><br>Sie können Cookies frei annehmen oder ablehnen, indem Sie unten auf die entsprechenden Kästchen klicken. Sie haben auch die Möglichkeit, Ihre Meinung jederzeit zu ändern, indem Sie über die dedizierte Registerkarte am Ende jeder Seite der Website auf dieses Cookie-Verwaltungsfeld zugreifen. Die Ablehnung bestimmter Cookies oder der Widerruf Ihrer Zustimmung kann die Funktionalität der Website beeinträchtigen.<br><br>Weitere Informationen zu den verwendeten Cookies und Trackern finden Sie in unserer <a href="/de/verwaltung-von-cookies/" class="cc-link">Cookie-Richtlinie</a>.',
                primary_btn: {
                    text: 'Ich stimme zu',
                    role: 'accept_all',             // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: 'Ich lehne ab',
                    role: 'accept_necessary',        // 'settings' or 'accept_necessary'
                },
                },
                settings_modal: {
                title: 'PRÄFERENZVERWALTUNG VON COOKIES',
                save_settings_btn: 'SPEICHERN',
                accept_all_btn: 'ALLES AKZEPTIEREN',
                reject_all_btn: 'ALLES ABLEHNEN',
                close_btn_label: 'Close',
                cookie_table_headers: [
                    {col1: 'Nom'},
                    {col2: 'Domaine'},
                    {col3: 'Expiration'},
                    {col4: 'Description'},
                ],
                blocks: [
                    {
                    description: 'Auf dieser Website verwenden wir Cookies, um unsere Besucherzahlen zu messen. Hier können Sie auswählen, welche Dienste Sie zulassen werden.',
                    }, {
                    title: 'COOKIES, DIE FÜR DAS FUNKTIONIEREN DER WEBSITE ERFORDERLICH SIND',
                    description: 'Diese Cookies sind für das reibungslose Funktionieren der Website unerlässlich. Diese Cookies sind für das Funktionieren der Website unerlässlich, Sie können sie nicht deaktivieren.',
                    toggle: {
                        value: 'necessary',
                        enabled: true,
                        readonly: true,
                    },
                    }, {
                    title: 'WERBETREIBENDE (ODER FAST)',
                    description: 'Um diese Website zu gestalten, haben wir uns an eine Firma aus unserem Ort (genauer gesagt in Nîmes) gewandt. Diese Firma stützt sich, um Ihre Website dynamischer zu gestalten, auf Technologien von Drittanbietern: YouTube, openmap usw. Um alle diese Technologien nutzen zu können, bitten wir Sie, diese Cookies zu akzeptieren.',
                    toggle: {
                        value: 'advertising',
                        enabled: false,
                        readonly: false,
                    },
                    },
                ],
                },
            },
          },
        });
    });
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
